// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader_yOGt1 {
  flex-basis: 80px;
  flex-shrink: 0;
  height: 80px;
  position: relative;
}

.image_Gpwuq {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  height: 50%;
}

.circle_BWQez {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  background-image: url( 'https://recovr-ui-assets.storage.googleapis.com/loader-circle.png' );
  background-repeat: no-repeat;
  background-size: cover;
}

.thumb_IT98z {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0px;
  background-image: url( 'https://recovr-ui-assets.storage.googleapis.com/loader-thumb.png' );
  background-repeat: no-repeat;
  background-size: cover;
}


@-webkit-keyframes rotating_ySyhp /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating_ySyhp {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating_ySyhp {
  -webkit-animation: rotating_ySyhp 2s linear infinite;
  -moz-animation: rotating_ySyhp 2s linear infinite;
  -ms-animation: rotating_ySyhp 2s linear infinite;
  -o-animation: rotating_ySyhp 2s linear infinite;
  animation: rotating_ySyhp 2s linear infinite;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/dashboard/viewer/theftRecovery/views/TRLoader.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,4FAA4F;EAC5F,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,2FAA2F;EAC3F,4BAA4B;EAC5B,sBAAsB;AACxB;;;AAGA;EACE;IACE,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,iCAAiC;IACjC,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE,oDAA8C;EAC9C,iDAA2C;EAC3C,gDAA0C;EAC1C,+CAAyC;EACzC,4CAAsC;AACxC","sourcesContent":[".loader {\n  flex-basis: 80px;\n  flex-shrink: 0;\n  height: 80px;\n  position: relative;\n}\n\n.image {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%,-50%);\n  height: 50%;\n}\n\n.circle {\n  width: 80px;\n  height: 80px;\n  position: absolute;\n  top: 0;\n  background-image: url( 'https://recovr-ui-assets.storage.googleapis.com/loader-circle.png' );\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.thumb {\n  width: 80px;\n  height: 80px;\n  position: absolute;\n  top: 0px;\n  background-image: url( 'https://recovr-ui-assets.storage.googleapis.com/loader-thumb.png' );\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n\n@-webkit-keyframes rotating /* Safari and Chrome */ {\n  from {\n    -webkit-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotating {\n  from {\n    -ms-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -webkit-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -ms-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n.rotating {\n  -webkit-animation: rotating 2s linear infinite;\n  -moz-animation: rotating 2s linear infinite;\n  -ms-animation: rotating 2s linear infinite;\n  -o-animation: rotating 2s linear infinite;\n  animation: rotating 2s linear infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `loader_yOGt1`,
	"image": `image_Gpwuq`,
	"circle": `circle_BWQez`,
	"thumb": `thumb_IT98z`,
	"rotating": `rotating_ySyhp`
};
export default ___CSS_LOADER_EXPORT___;
